export enum AgencyHeaderKeys {
  companyLogoLink = 'companyLogoLink',
  primaryEmailAddress = 'primaryEmailAddress',
  primaryPhoneNumber = 'primaryPhoneNumber',
  primaryShippingAddress = 'primaryShippingAddress',
  primaryBillingAddress = 'primaryBillingAddress',
}
